import { Location, isPlatformBrowser } from "@angular/common";
import { EventEmitter, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { ConfirmDialogService } from '@common/ui/frontend-shared/confirmdialog';
import * as i0 from "@angular/core";
import * as i1 from "@common/ui/frontend-shared/confirmdialog";
import * as i2 from "@angular/common";
// TODO: Catch browser back button event
let instanced = false;
export let NavigationService = /*#__PURE__*/(() => {
  class NavigationService {
    get warnOnLeave() {
      return this._warnOnLeave;
    }
    get warnOnNavigate() {
      return this._warnOnNavigate;
    }
    constructor(confirmationService, location, rendererFactory2, platformId) {
      this.confirmationService = confirmationService;
      this.location = location;
      this.rendererFactory2 = rendererFactory2;
      this.platformId = platformId;
      this.warningRefList = [];
      this._warnOnLeave = false;
      this._warnOnNavigate = false;
      this.events$ = new EventEmitter();
      this.isBrowser = isPlatformBrowser(this.platformId);
      if (this.isBrowser) {
        if (instanced) throw new Error('Tried to create more than one NavigationService!');
        instanced = true;
        window.addEventListener('beforeunload', event => {
          this.onBeforeCloseWindow(event);
        });
        window.addEventListener('popstate', event => {
          this.onBeforeCloseWindow(event);
        });
      }
      this.renderer = this.rendererFactory2.createRenderer(null, null);
    }
    enableWarning(entry) {
      this.disableWarning(entry);
      this.warningRefList.push(entry);
      this._updateWarnings();
    }
    disableWarning(entryOrIdToRemove) {
      const id = typeof entryOrIdToRemove === 'string' ? entryOrIdToRemove : entryOrIdToRemove.id;
      this.warningRefList = this.warningRefList.reduce((newList, entry) => {
        if (entry.id !== id) newList.push(entry);
        return newList;
      }, []);
      this._updateWarnings();
    }
    clearAllWarnings() {
      this.warningRefList = [];
      this._updateWarnings();
    }
    // returns async true if navigation is not blocked or user states he really wants to navigate.
    intercept(url, extras) {
      return new Promise((res, rej) => {
        if (!this._warnOnNavigate) {
          res(true);
          return;
        }
        // find first custom message within the list of navWarnings
        const message = this.warningRefList.reduce((result, navWarning) => {
          return result ? result : navWarning.message || '';
        }, '');
        this.confirmationService.confirm({
          message: message || `Warnung: Es gibt noch laufende Uploads oder ungespeicherte Daten. Wirklich die Seite verlassen?`,
          acceptLabel: 'Weiter',
          rejectLabel: 'Zurück',
          accept: () => {
            // user wants to continue navigation
            this.clearAllWarnings();
            res(true);
          },
          reject: () => {
            // user decided to stay on page
            res(false);
          }
        });
      });
    }
    // @HostListener('window:beforeunload', ['$event'])
    onBeforeCloseWindow(event) {
      if (!this.warnOnLeave) return true;
      event.preventDefault();
      event['returnValue'] = false;
      return false;
    }
    _updateWarnings() {
      // reset
      this._warnOnNavigate = this._warnOnLeave = false;
      this.bindNavigationWarnings(false);
      // check
      this.warningRefList.forEach(entry => {
        if (entry.leave) this._warnOnLeave = true;
        if (entry.navigate) this._warnOnNavigate = true;
      });
      // bind
      if (this._warnOnNavigate) {
        this.bindNavigationWarnings(true);
        this.events$.emit({
          enabled: true,
          activeWarnings: this.warningRefList.map(entry => entry.id)
        });
      } else {
        this.events$.emit({
          enabled: false
        });
      }
    }
    bindNavigationWarnings(enable) {
      if (enable) {
        this.unbindKeyPressEvent = this.renderer.listen('document', 'keydown', e => {
          if (e.key === 'Backspace') {
            // console.log(e);
            if (this._warnOnNavigate) {
              // only block event if no element is focused, this would block editing!
              if (['#document', 'HTML', 'BODY'].includes(e.target.nodeName)) {
                // TODO: Show confirmation dialog when user presses backspace.
                // confirmationService currently fails, it will not show until user clicks somewhere.
                // for now just block the back event.
                e.preventDefault();
                // this.checkWarnOnNavigate().then(continueNav=>{
                // 	this.location.back()
                // })
              }
            }
          }
        });
      } else {
        if (typeof this.unbindKeyPressEvent === 'function') this.unbindKeyPressEvent();
      }
    }
    static {
      this.ɵfac = function NavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NavigationService)(i0.ɵɵinject(i1.ConfirmDialogService), i0.ɵɵinject(i2.Location), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: NavigationService,
        factory: NavigationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NavigationService;
})();